import type {TariffFiltersValue,TariffsCargoInfo} from '../../../model/tariffs'
import type {DropdownListFilter, TariffInfoResponse, TariffsCargoInfoBody} from '../../../repo/tariffs'
import {toBlocksByColumns} from './toBlocksByColumns'

export function toCargoInfoBody(zone: string, tariff: string, filters?: TariffFiltersValue) {
  const body: TariffsCargoInfoBody = {
    zone_name: zone,
    tariff,
  }

  if (filters) {
    body.filters = Object.entries(filters).map(([id, value]) => {
      return {
        id,
        value,
      }
    })
  }

  return body
}

function isDropdownListFilter(filter: unknown): filter is DropdownListFilter {
  return typeof filter === 'object' && filter !== null && 'id' in filter && 'options' in filter
}

export function toTariffsCargoInfo({
  map_polygon,
  tariff_info_by_payment_kind,
  filters,
}: TariffInfoResponse): TariffsCargoInfo {
  const tariffsInfo = tariff_info_by_payment_kind.map(({payment_kind, blocks, payment_kind_name, disable_reason}) => ({
    paymentKind: payment_kind,
    paymentKindTitle: payment_kind_name,
    disableReason: disable_reason,
    blocks: toBlocksByColumns(blocks),
  }))

  return {
    mapPolygon: map_polygon as [number, number][],
    tariffsInfo,
    filters: filters.filter(isDropdownListFilter),
  }
}
